import { Component, Inject, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import {TooltipPosition} from '@angular/material/tooltip';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { EntrevistaService } from '@app/services/entrevista.service';
import { Entrevista, EntrevistaPergunta, EntrevistaGrupo } from '@app/models/entrevista.model';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-entrevista-form',
  templateUrl: './entrevista-form.component.html',
  styleUrls: ['./entrevista-form.component.scss']
})
export class EntrevistaFormComponent implements OnInit {

  aguardandoSolicitacao = false;
  entrevista: Entrevista = new Entrevista();
  titulo: string;

  pergunta: string;
  modalRef: BsModalRef;
  modalEditarPerguntaRef: BsModalRef;
  modalRefDeletarPergunta: BsModalRef;

  modalRefNovoGrupo: BsModalRef;
  modalRefEditarGrupo: BsModalRef;
  modalRefDeletarGrupo: BsModalRef;

  novoGrupo: EntrevistaGrupo;
  editarGrupo: EntrevistaGrupo;
  novaPergunta: EntrevistaPergunta;
  editarPergunta: EntrevistaPergunta;
  deletarPergunta: EntrevistaPergunta;
  lstErros: string[];
  lstPerguntas = [];
  indexGrupo = 0;
  possuiStorage = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private modalService: BsModalService,
    private entrevistaService: EntrevistaService,
    @Inject(ToastrService) public toastr: ToastrService,
    vcr: ViewContainerRef
  ) {

    this.novoGrupo = new EntrevistaGrupo();
    this.novoGrupo.Perguntas = [];
    this.novoGrupo.Id = 0;
  }

  ngOnInit() {
    // const id = this.route.params.subscribe(params => {
    this.route.params.subscribe(params => {
      const id = params['id'];
      this.titulo = id ? 'Editar Entrevista' : 'Nova Entrevista';

      if (window.sessionStorage.getItem('entrevista')) {
        this.possuiStorage = true;
      }

      if (!id) {
        return;
      }

      this.entrevistaService.obterPorId(id)
        .subscribe(
          data => {
            this.entrevista = data;
            if (this.entrevista.Grupos == null) {
              this.entrevista.Grupos = [];
            }
            this.entrevista.Grupos.forEach(e => this.lstPerguntas.push(e.Perguntas));
          },
          data => this.router.navigate(['./configuracoes/entrevista']));
    });
  }

  obterGrupoDoEvento(grupo) {
    this.indexGrupo = grupo.Ordem;
  }

  drop(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.lstPerguntas[this.indexGrupo], event.previousIndex, event.currentIndex);
    window.sessionStorage.setItem('entrevista', JSON.stringify(this.entrevista));
  }

  // pergunta
  openModalNovaPergunta(template: TemplateRef<any>, grupoId: number = null) {
    this.aguardandoSolicitacao = false;
    this.novaPergunta = new EntrevistaPergunta();
    this.novaPergunta.Tipo = 'TEXT';
    if (grupoId) {
      this.novaPergunta.EntrevistaGrupoId = grupoId;
    }
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'gray modal-lg'
    };
    this.modalRef = this.modalService.show(template, config);
    window.sessionStorage.setItem('entrevista', JSON.stringify(this.entrevista));
  }

  public recuperarEntrevista() {
    if (window.sessionStorage.getItem('entrevista')) {
      this.entrevista = JSON.parse(window.sessionStorage.getItem('entrevista'));
    }
  }

  public limparCache() {
    if (window.sessionStorage.getItem('entrevista')) {
      window.sessionStorage.removeItem('entrevista');
    }
    this.possuiStorage = false;
  }

  public salvaNovaPergunta() {
    if (this.novaPergunta != null) {
      if (!this.novaPergunta.Pergunta || this.novaPergunta.Pergunta.trim() === '') {
        this.toastr.error('Informe a pergunta');
        return;
      }

      if (!this.novaPergunta.EntrevistaGrupoId) {
        this.toastr.error('Informe um grupo');
        return;
      }

      if (!this.novaPergunta.Tipo || this.novaPergunta.Tipo.trim() === '') {
        this.toastr.error('Informe um tipo de campo');
        return;
      }

      const grupo = this.entrevista.Grupos.find(x => x.Id.toString() === this.novaPergunta.EntrevistaGrupoId.toString());
      const index = this.entrevista.Grupos.indexOf(grupo);
      this.entrevista.Grupos[index].Perguntas.push(this.novaPergunta);
      window.sessionStorage.setItem('entrevista', JSON.stringify(this.entrevista));
      this.modalRef.hide();
    }
  }

  abreModalEditaPergunta(template: TemplateRef<any>, editarPergunta: EntrevistaPergunta) {
    this.editarPergunta = { ...editarPergunta };
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'gray'
    };
    this.modalEditarPerguntaRef = this.modalService.show(template, config);
  }


  public salvarEditarPergunta() {
    let pergunta = null;
    let grupo = null;
    let indexGrupo = null;
    let indexPergunta = null;
    for (let i = 0; i < this.entrevista.Grupos.length; i++) {
      grupo = this.entrevista.Grupos[i];
      pergunta = this.entrevista.Grupos[i].Perguntas.find(x => x.Id === this.editarPergunta.Id);
      if (pergunta) {
        indexGrupo = i;
        indexPergunta = this.entrevista.Grupos[i].Perguntas.indexOf(pergunta);
        break;
      }
    }
    if (pergunta) {
      if (grupo.Id === this.editarPergunta.EntrevistaGrupoId) {
        this.entrevista.Grupos[indexGrupo].Perguntas[indexPergunta] = { ...this.editarPergunta };
      } else {
        const novoGrupo = this.entrevista.Grupos.find(x => x.Id === this.editarPergunta.EntrevistaGrupoId);
        if (novoGrupo) {
          this.entrevista.Grupos[indexGrupo].Perguntas.splice(indexPergunta, 1);
          const indexNovoGrupo = this.entrevista.Grupos.indexOf(novoGrupo);
          this.entrevista.Grupos[indexNovoGrupo].Perguntas.push({ ...this.editarPergunta });
        }
      }
      this.toastr.success('Pergunta editada com sucesso!');
    } else {
      this.toastr.error('Ops.. não foi possível editar o pergunta');
    }
    // this.entrevistaService; - parece sem utilidade aqui
    this.modalEditarPerguntaRef.hide();
  }



  public deletarPerguntaConfirmar(): void {
    const grupo = this.entrevista.Grupos.find(x => x.Id.toString() === this.deletarPergunta.EntrevistaGrupoId.toString());

    if (grupo) {
      if (this.deletarPergunta.Id > 0) {
        const indexGrupo = this.entrevista.Grupos.indexOf(grupo);
        const indexPergunta = this.entrevista.Grupos[indexGrupo].Perguntas.indexOf(this.deletarPergunta);
        this.entrevista.Grupos[indexGrupo].Perguntas[indexPergunta].Deletado = true;
      } else {
        const indexGrupo = this.entrevista.Grupos.indexOf(grupo);
        const indexPergunta = this.entrevista.Grupos[indexGrupo].Perguntas.indexOf(this.deletarPergunta);
        this.entrevista.Grupos[indexGrupo].Perguntas.splice(indexPergunta, 1);
      }
      this.toastr.success('Pergunta deletada com sucesso!');
      this.modalRefDeletarPergunta.hide();
    } else {
      this.toastr.error('Ops.. não foi possível deletar a pergunta');
    }
    window.sessionStorage.setItem('entrevista', JSON.stringify(this.entrevista));
  }


  public abreModalDeletarPergunta(template: TemplateRef<any>, pergunta: EntrevistaPergunta) {
    this.deletarPergunta = pergunta;
    this.modalRefDeletarPergunta = this.modalService.show(template);
  }

  // grupo
  abreModalNovoGrupo(template: TemplateRef<any>) {
    this.novoGrupo = new EntrevistaGrupo();
    this.novoGrupo.Perguntas = [];
    this.novoGrupo.Id = 0;
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'gray modal-sm'
    };
    this.modalRefNovoGrupo = this.modalService.show(template, config);
  }

  public salvarNovoGrupo() {
    if (this.novoGrupo != null && this.novoGrupo.Descricao != null && this.novoGrupo.Descricao !== '') {
      this.novoGrupo.Id = this.randomId();
      this.entrevista.Grupos.push(this.novoGrupo);
      this.modalRefNovoGrupo.hide();
    } else {
      this.toastr.error('Informe o nome do grupo');
    }
  }

  abreModalEditarGrupo(template: TemplateRef<any>, editarGrupo: EntrevistaGrupo) {
    this.editarGrupo = { ...editarGrupo };
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'gray'
    };
    this.modalRefEditarGrupo = this.modalService.show(template, config);
    window.sessionStorage.setItem('entrevista', JSON.stringify(this.entrevista));
  }

  public salvarEditarGrupo() {
    const grupo = this.entrevista.Grupos.find(x => x.Id === this.editarGrupo.Id);
    const index = this.entrevista.Grupos.indexOf(grupo);
    if (grupo) {
      this.entrevista.Grupos[index] = { ...this.editarGrupo };
      this.toastr.success('Grupo editado com sucesso!');
    } else {
      this.toastr.error('Ops.. não foi possível editar o grupo');
    }
    this.modalRefEditarGrupo.hide();
  }

  public abreModalDeletarGrupo(template: TemplateRef<any>) {
    this.modalRefEditarGrupo.hide();
    this.modalRefDeletarGrupo = this.modalService.show(template);
  }

  public deletarGrupo() {
    const grupo = this.entrevista.Grupos.find(x => x.Id === this.editarGrupo.Id);
    if (grupo) {
      const index = this.entrevista.Grupos.indexOf(grupo);
      this.entrevista.Grupos[index].Deletado = true;
      this.toastr.success('Grupo deletado com sucesso!');
    } else {
      this.toastr.error('Ops... não foi possível deletar o grupo');
    }
    this.modalRefDeletarGrupo.hide();
    window.sessionStorage.setItem('entrevista', JSON.stringify(this.entrevista));
  }
  //
  onSubmit() {
    this.aguardandoSolicitacao = true;
    this.geraOrdem();
    this.entrevistaService.gravar(this.entrevista)
      .subscribe(() => {
        this.router.navigate(['./configuracoes/entrevista']);
        window.sessionStorage.removeItem('entrevista');
      }, (error) => {
        this.aguardandoSolicitacao = false;
        this.lstErros = error.error.errors;
      });
  }

  voltar() {
    window.sessionStorage.removeItem('entrevista');
  }

  geraOrdem() {
    let ordemGrupo = 0;
    for (let i = 0; i < this.entrevista.Grupos.length; i++) {
      let ordermPergunta = 0;
      this.entrevista.Grupos[i].Ordem = ordemGrupo;
      for (let p = 0; p < this.entrevista.Grupos[i].Perguntas.length; p++) {
        if (!this.entrevista.Grupos[i].Perguntas[p].Deletado) {
          this.entrevista.Grupos[i].Perguntas[p].Ordem = ordermPergunta;
          ordermPergunta++;
        }
      }
      ordemGrupo++;
    }
  }


  public movePergunta(item: any, list: any[]): void {
    list.splice(list.indexOf(item), 1);
  }

  public obterPerguntas(list: EntrevistaPergunta[]) {
    return list.filter(x => x.Deletado != true);
  }

  public obterGrupos(list: EntrevistaGrupo[]) {
    return list.filter(x => x.Deletado != true);
  }

  public moverLista(arr: any[], fromIndex: number, toIndex: number) {
    const element = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
  }

  // util
  private randomId() {
    while (true) {
      const id = (Math.floor(Math.random() * 100000000) + 1) * -1;
      const grupo = this.entrevista.Grupos.find(x => x.Id === id);
      if (!grupo) {
        return id;
      }
    }
  }

  public retornaTipoCampo(tipo: string) {
    if (tipo) {
      switch (tipo.toUpperCase()) {
        case 'TEXT':
          return 'Texto';
        case 'TEXT2':
          return 'Caixa de texo';
        case 'BOOL':
          return 'Seleção (Sim/Não)';
        default:
          return '';
      }
    }
  }
}
